import React from 'react';
import Navbar from '../components/Navbar';
import Breadcrumb from '../components/Breadcrumb';
import ContentSplitSections from '../components/ContentSplitSections';
import { Link } from 'react-router-dom';
import '../styles/landscape.css';
import CTASection from '../components/CTASection';

// Design/Build service data
const designBuildServices = [
  {
    title: "Landscape Design",
   text: `Your Vision, Our Expertise\n\nEvery property has its own potential and we're here to help you bring that to life. Our design process starts and needs with listening. Understanding how you use your space, how you want it to feel, and what will make it last is key to our success.\n\nWe tailor each plan to their unique property needs and functionality, blending creativity with practicality. From classic lawns to naturalized, water-wise landscapes, every project is designed for beauty, function, and longevity.\n\nDesign Considerations:\n• Microclimate and site analysis\n• Low-maintenance plant selection\n• Efficient irrigation planning\n• Snow and water flow management\n• Wildlife and pet-friendly design`,
    image: "/images/blueLand.jpg",
    alt: "Custom landscape design plans",
    reverse: false
  },
  {
    title: "Professional Installation",
    text: `From Plans to Places\n\nOur installation teams bring decades of experience and the same attention to detail to every project- whether it's a small courtyard or a full estate.\n\nWe partner closely with contractors, architects, and homeowners to ensure every element comes together seamlessly.\n\nInstallation Highlights:\n• Soil and grading preparation\n• Precision plant placement\n• Drainage and irrigation integration\n• Expert hardscape coordination`,
    image: "/images/landscape/treeInstallIsland1.jpeg",
    alt: "Professional landscape installation",
    reverse: true
  },
  {
    title: "Sustainable Practices",
    text: `Landscapes That Last\n\nWe believe sustainability is simply a good design. By selecting adaptive plants, planning water efficiency, and minimizing chemical inputs, we create outdoor environments that thrive naturally and require less overtime.\n\nSustainability Features:\n• Water-wise irrigation systems\n• Reduced chemical use\n• Native and adaptive plantings\n• Integrated pest management\n• Kid, trout, and pet-safe practices`,
    image: "/images/landscape/landscapeAll.jpg",
    alt: "Sustainable landscape practices",
    reverse: false
  }
];

const maintenanceServices = [
  {
    title: "Lawn & Turf Care",
    text: `Proper mowing, fertilization, and aeration are the foundations of a healthy landscape. Our crews adjust techniques to each property's conditions and the changing seasons, ensuring consistent, professional results.\n\nServices include:\n• Weekly mowing and edging\n• Seasonal height adjustments\n• Turf health and fertilization programs\n• Native and low-mow turf care\n• Debris removal and site cleanup`,
    image: "/images/landscape/landscapeBack.jpg",
    alt: "Professional lawn maintenance",
    reverse: false
  },
  {
    title: "Tree & Shrub Care",
    text: `Our pruning crews bring skill and care to every property, maintaining structure, shape, and plant health across Idaho's diverse species. From selective trimming to storm cleanup, we promote long-term vitality and balance.\n\nServices include:\n• Seasonal pruning and shaping\n• Disease prevention and treatment\n• Growth management and training\n• Storm damage cleanup\n• Deep-root fertilization`,
    image: "/images/landscape/treeShrub3.jpg",
    alt: "Professional tree and shrub pruning",
    reverse: true
  },
  {
  title: "Seasonal & Floral Displays",
  text: `Add color, texture, and character to your property in every season. Our on-site greenhouse produces locally grown selections that complement Idaho's climate while supporting sustainability and beauty.\n\nServices include:\n• Custom floral design and installation\n• Seasonal flowerbed and container rotations\n• Greenhouse-grown and native plant selections\n• Ongoing maintenance and seasonal refreshes`,
  image: "/images/flower/flowersBright1.jpg",
  alt: "Seasonal flower displays in Sun Valley",
}


];

const Landscape = () => {
  return (
    <div className="landscape-page">
      <Navbar />
      <Breadcrumb customLabel="Design & Build" />
      {/* Hero Section */}
      <section 
        className="landscape-hero">
        <img 
          src="/images/landscape/LandscapeHero5.jpg" 
          alt="Beautiful Flower Garden" 
          className="hero-image"
          loading="eager"
          decoding="async"
        />
        <div className="landscape-hero-content">
          <h1 className="landscape-hero-title">Creating & Maintaining Sun Valley's Finest Landscapes</h1>
          <p className="landscape-hero-subtitle">
            We bring care and craftsmanship to every outdoor space. From design and installation to year-round maintenance, one call handles it all.
          </p>
          <div className="hero-buttons">
            <Link to="mailto:info@allseasons.info">
                     <button className="btn-cta"
                     target="_blank"
                     rel="noopener noreferrer" style={{ textTransform: "uppercase" }}>
                       Request a Consultation
                     </button>
                     </Link>
            <Link to="/gallery/landscape" className="btn-primary">Gallery</Link>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="section bg-white">
        <div className="section-inner">
          <div className="intro-content">
            <h2 className="section-title text-center">Landscapes That Live and Breathe</h2>
            <p className="intro-text">
             At All Seasons, we don't just install landscapes — we build outdoor spaces that grow with you. Every project is designed around your property, your lifestyle, and Idaho's changing seasons. From timeless green lawns to water-wise plantings, our team balances beauty and function to create landscapes that last.
            </p>
          </div>
        </div>
      </section>

<section className="section bg-white section-divider-editorial">
  <div className="section-inner">
    <h2 className="section-title text-center">Design & Build Excellence</h2>
    <p className="section-subtitle text-center">Where creativity meets expertise to transform your outdoor spaces</p>
  </div>
</section>

<ContentSplitSections sections={designBuildServices} />

      {/* Gallery CTA */}
      <section className="section bg-white">
        <div className="section-inner text-center">
          <Link to="/Gallery/landscape" className="btn-primary">
            View Our Work
          </Link>
        </div>
      </section>

<section className="section bg-white section-divider-editorial">
  <div className="section-inner">
    <h2 className="section-title text-center">Professional Maintenance & Care</h2>
    <p className="section-subtitle text-center">Our maintenance programs are customized for each property, balancing seasonal needs with long-term health.</p>
  </div>
</section>

<ContentSplitSections sections={maintenanceServices} />

      {/* Gallery CTA */}
      <section className="section bg-white">
        <div className="section-inner text-center">
          <Link to="/Gallery/landscape" className="btn-primary">
            View Our Work
          </Link>
        </div>
      </section>

      {/* Naturalistic Design Services */}
      {/* {activeService === 'naturalistic' && (
        <NaturalisticDesignSection layout="full" />
      )} */}

      {/* Comprehensive Services Grid */}
      <section className="section bg-clean-snow services-overview">
        <div className="section-inner">
          <h2 className="section-title text-center">Comprehensive Landscape Services</h2>
          <div className="services-grid">
            <div className="service-category">
              <h3>Lawn Services</h3>
              <ul>
                <li>Professional mowing</li>
                <li>Fertilization programs</li>
                <li>Weed & pest control</li>
                <li>Aeration & overseeding</li>
                <li>Native lawn installation</li>
              </ul>
            </div>
            <div className="service-category">
              <h3>Plant Care</h3>
              <ul>
                <li>Tree & shrub pruning</li>
                <li>Disease management</li>
                <li>Deep root fertilization</li>
                <li>Storm damage cleanup</li>
                <li>Plant health assessments</li>
              </ul>
            </div>
            <div className="service-category">
              <h3>Seasonal Services</h3>
              <ul>
                <li>Spring activation</li>
                <li>Fall cleanup</li>
                <li>Winterization</li>
                <li>Holiday lighting</li>
                <li>Seasonal color rotation</li>
              </ul>
            </div>
            <div className="service-category">
              <h3>Specialty Care</h3>
              <ul>
                <li>Irrigation management</li>
                <li>Water feature maintenance</li>
                <li>Bed maintenance</li>
                <li>Mulch installation</li>
                <li>Landscape enhancements</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
     <CTASection 
  title="READY TO CREATE YOUR DREAM LANDSCAPE?"
  subtitle="WHETHER YOU NEED A COMPLETE DESIGN OR ONGOING MAINTENANCE, WE'RE HERE TO HELP"
  galleryLink="/Gallery/landscape"
  showEmergency={true}
/>
    </div>
  );
};

export default Landscape;